import React, { useEffect, useState } from 'react';

/**
 * Responsive Sidebar
 * - Desktop (>=1100px): fixed left sidebar
 * - Mobile (<1100px): top bar + hamburger drawer
 * Improvements:
 *   • Scrollable link area
 *   • Sticky admin action at the bottom (always reachable)
 *   • Slightly denser layout on short viewports
 */
export default function Sidebar({
  activeSection,
  setActiveSection,
  adminUser,
  onAdminClick,
  onLogout,
}) {
  const links = [
    { key: 'welcome',  label: '💜 Welcome' },
    { key: 'video',    label: '🎞️ Tribute Video' },
    { key: 'insta360', label: '🧭 Memorial 360°' },
    { key: 'obituary', label: '🕊️ Obituary' },
    { key: 'donate',   label: '💸 Donation Info' },
    { key: 'funeral',  label: '🕯️ Funeral & Visitation' },
    { key: 'gallery',  label: '📸 Photo & Video Gallery' },
    { key: 'guestbook',label: '💬 Guestbook & Tributes' },
    { key: 'contact',  label: '📧 Contact Us' },
  ];
  if (adminUser) links.push({ key: 'pending', label: '🛠 Pending Submissions' });

  // Mobile drawer state
  const [open, setOpen] = useState(false);

  // Lock scroll when drawer is open
  useEffect(() => {
    if (open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => (document.body.style.overflow = prev);
    }
  }, [open]);

  const LinkButtons = ({ onNavigate }) => (
    <>
      {links.map(link => (
        <button
          key={link.key}
          className={`sidebar-btn ${activeSection === link.key ? 'active' : ''}`}
          onClick={() => { onNavigate(); setActiveSection(link.key); }}
        >
          {link.label}
        </button>
      ))}
    </>
  );

  const AdminBlock = ({ onNavigate }) => (
    <div className="sidebar-admin">
      {!adminUser ? (
        <button
          className="sidebar-btn sidebar-admin-btn"
          onClick={() => { onNavigate(); onAdminClick(); }}
        >
          Admin Login
        </button>
      ) : (
        <button
          className="sidebar-btn sidebar-admin-btn logout"
          onClick={() => { onNavigate(); onLogout(); }}
        >
          Logout
        </button>
      )}
    </div>
  );

  return (
    <>
      {/* Desktop sidebar */}
      <aside className="sidebar-nav sidebar-desktop">
        <div className="sidebar-scroll">
          <LinkButtons onNavigate={() => { /* stay open on desktop */ }} />
        </div>
        <AdminBlock onNavigate={() => { /* stay open on desktop */ }} />
      </aside>

      {/* Mobile top bar + drawer */}
      <div className="mobile-topbar">
        <button
          className="hamburger-btn"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open ? 'true' : 'false'}
          onClick={() => setOpen(!open)}
        >
          <span className={`hamburger-lines ${open ? 'open' : ''}`} />
          <span className="hamburger-text">Menu</span>
        </button>
        <div className="mobile-title">Theyda • Memorial</div>
      </div>

      {open && <div className="mobile-drawer-backdrop" onClick={() => setOpen(false)} />}
      <aside className={`mobile-drawer ${open ? 'show' : ''}`} role="dialog" aria-modal="true">
        <div className="mobile-drawer-inner">
          <div className="sidebar-scroll">
            <LinkButtons onNavigate={() => setOpen(false)} />
          </div>
          <AdminBlock onNavigate={() => setOpen(false)} />
        </div>
      </aside>
    </>
  );
}
